import { mapActions } from "vuex";

export default {
    methods: {
        ...mapActions({
            saveAll: 'crudStore/saveAll',
            assignDataForm: 'crudStore/assignDataForm',
        }),
        async saveForm(event) {
            try {
                if (event.ftn !== undefined) {
                    switch (event.ftn) {
                        case 'guardarFtn':
                            var name = this.dataForm[this.namePath].datos_afiliado.nombre1 + ' ' + this.dataForm[this.namePath].datos_afiliado.nombre2 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido1 + ' ' + this.dataForm[this.namePath].datos_afiliado.apellido2
                            var re = /null/gi;

                            await this.updateDataForm({ state: 'datos_afiliado/name', data: name.replace(re, ' ') })
                            if (this.user.admin === 1) {
                                if (this.dataForm[this.namePath].datos_afiliado.id_list_estado === 2) {
                                    let activosServicios = this.deepCopy(this.dataForm[this.namePath].servicios_activos)

                                    let servicios_inits = []

                                    for (let j = 0; j < activosServicios.length; j++) {
                                        let inits = activosServicios[j]
                                        inits.id = null
                                        inits.deleted_at = this.fecha().fecha.hoy
                                        inits.retiro = null
                                        inits.nota_delete = 'inactivado en ficha afiliado'
                                        servicios_inits.push(inits)
                                    }

                                    await this.updateDataForm({ state: 'servicios_inits', data: servicios_inits })

                                    await this.updateDataPost({
                                        data: {
                                            data: [],
                                            route: 'save_all',
                                            tablaAuditar: true,
                                            notaDelete: null,
                                            tablaPost: ['datos_afiliado', 'info_afiliacion', 'servicios_activos', 'servicios_nuevos', 'servicios_inits'],
                                            tablaDelete: ['info_afiliacion', 'servicios_activos', 'servicios_nuevos']
                                        }
                                    })
                                } else {
                                    if (this.estado === 1) {
                                        let nuevosServicios = this.deepCopy(this.dataForm[this.namePath].servicios_nuevos)
                                        let id_afiliacion_registro = _.filter(this.dataForm[this.namePath].servicios_activos, ['name', 'Administración'])
                                        id_afiliacion_registro = id_afiliacion_registro[0].id_afiliacion_registro
                                        await this.updateDataPost({
                                            data: {
                                                data: [{ servicios_nuevos: this.dataForm[this.namePath].servicios_nuevos, servicios_activos: this.dataForm[this.namePath].servicios_activos }],
                                                tablaDelete: ['servicios_nuevos', 'servicios_activos'],
                                                tablaAuditar: true,
                                                notaDelete: null,
                                                tablaPost: [],
                                                route: 'save_all'
                                            }
                                        })
                                        await this.save(false, true)
                                            // resetea servicios nuevos y asigna los check de dataMultiple a servicios_nuevos y asigno servicios_Activos
                                        await this.resetDataForm({ state: 'servicios_activos' })
                                        await this.resetDataForm({ state: 'servicios_nuevos' })

                                        for (let i = 0; i < this.dataMultiple[this.namePath].multiple_servicios.length; i++) {
                                            if (this.dataMultiple[this.namePath].multiple_servicios[i].check === 1) {
                                                let newValue = this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
                                                newValue.id = null
                                                if (newValue.id_afiliacion_registro === null) {
                                                    newValue.id_afiliacion_registro = id_afiliacion_registro
                                                }
                                                if (newValue.id_info_ingresos === null) {
                                                    newValue.id_info_ingresos = 0
                                                }
                                                if (this.dataMultiple[this.namePath].multiple_servicios[i].name === 'Administración') {
                                                    newValue.mes_periodo = this.dataForm[this.namePath].info_afiliacion.mes_periodo
                                                    newValue.ano_periodo = this.dataForm[this.namePath].info_afiliacion.ano_periodo
                                                }
                                                if (this.dataMultiple[this.namePath].multiple_servicios[i].name !== 'Traslado') {

                                                    if (_.findIndex(nuevosServicios, ['name', newValue.name]) !== -1) {
                                                        newValue.iniciolabores = null
                                                        await this.pushDataForm({ state: 'servicios_nuevos', data: newValue })
                                                    }
                                                    await this.pushDataForm({ state: 'servicios_activos', data: newValue })
                                                } else {
                                                    newValue.iniciolabores = null
                                                    newValue.mes_periodo = null
                                                    newValue.ano_periodo = null
                                                    await this.pushDataForm({ state: 'servicios_nuevos', data: newValue })
                                                }

                                            }
                                        }

                                        let descuentos_referidos = {}
                                        if (this.dataForm[this.namePath].datos_afiliado.referido !== null && this.dataForm[this.namePath].descuentos_referido.descuento > 0) {
                                            descuentos_referidos.id = null
                                            descuentos_referidos.referido = { name: name.replace(re, ' '), documento: this.dataForm[this.namePath].datos_afiliado.documento }
                                            descuentos_referidos.id_datos_afiliado = this.dataForm[this.namePath].datos_afiliado.referido.id
                                            descuentos_referidos.id_info_afiliacion = null,
                                                descuentos_referidos.descuento = this.dataForm[this.namePath].descuentos_referido.descuento

                                            this.updateDataForm({ state: 'descuentos_referido', data: descuentos_referidos })

                                            await this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado', 'info_afiliacion', 'servicios_nuevos', 'servicios_activos', 'descuentos_referido'] })
                                        } else {
                                            await this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado', 'info_afiliacion', 'servicios_nuevos', 'servicios_activos'] })
                                        }


                                        // se configura el dataPost
                                        const await8 = this.updateDataPost({ state: 'data', data: [] })
                                        const await9 = this.updateDataPost({ state: 'route', data: 'save_all' })
                                        const await10 = this.updateDataPost({ state: 'tablaDelete', data: [] })
                                        await Promise.all([await8, await9, await10])
                                    } else {
                                        // asigna los check de dataMultiple a servicios_Activos
                                        for (let i = 0; i < this.dataMultiple[this.namePath].multiple_servicios.length; i++) {
                                            if (this.dataMultiple[this.namePath].multiple_servicios[i].check === 1) {
                                                let newValue = this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
                                                newValue.id = null
                                                if (this.dataMultiple[this.namePath].multiple_servicios[i].name === 'Administración') {
                                                    newValue.mes_periodo = this.dataForm[this.namePath].info_afiliacion.mes_periodo
                                                    newValue.ano_periodo = this.dataForm[this.namePath].info_afiliacion.ano_periodo
                                                }
                                                if (this.dataMultiple[this.namePath].multiple_servicios[i].name !== 'Traslado') {
                                                    await this.pushDataForm({ state: 'servicios_activos', data: newValue })
                                                } else {
                                                    newValue.iniciolabores = null
                                                    newValue.mes_periodo = null
                                                    newValue.ano_periodo = null
                                                    await this.pushDataForm({ state: 'servicios_nuevos', data: newValue })
                                                }

                                            }
                                        }

                                        // se actualizan datos de info_Afiliacion y afiliacion_registro
                                        let info_afiliacion = {
                                            id: null,
                                            id_list_users: this.user.id,
                                            fecha: this.fecha().fecha.minHoy,
                                            salariobase: this.dataForm[this.namePath].info_afiliacion.salario,
                                        }

                                        const await1 = this.assignDataForm({ state: 'info_afiliacion', data: info_afiliacion })

                                        let afiliacion_registro = {
                                            valor: 0,
                                            comision: 0,
                                            reporte: 0,
                                            id_info_ingresos: 0,
                                            fecha: this.fecha().fecha.minHoy,
                                            id_datos_razon: this.dataForm[this.namePath].info_afiliacion.id_datos_razon,
                                            id_datos_asesor: this.dataForm[this.namePath].info_afiliacion.id_datos_asesor,
                                            servicios: this.dataForm[this.namePath].servicios_activos
                                        }

                                        const await2 = this.assignDataForm({ state: 'afiliacion_registro', data: afiliacion_registro })

                                        let datos_afiliado = datos_afiliado = {
                                            name: name.replace(re, ' '),
                                            id_list_estado: 1
                                        }

                                        const await3 = this.assignDataForm({ state: 'datos_afiliado', data: datos_afiliado })
                                        const await4 = this.updateDataPost({ state: 'route', data: 'save_all' })
                                        const await5 = this.updateDataPost({ state: 'tablaDelete', data: [] })
                                        const await6 = this.updateDataPost({ state: 'data', data: [] })

                                        let descuentos_referidos = {}
                                        if (this.dataForm[this.namePath].datos_afiliado.referido !== null && this.dataForm[this.namePath].descuentos_referido.descuento > 0) {
                                            descuentos_referidos.id = null
                                            descuentos_referidos.referido = { name: name.replace(re, ' '), documento: this.dataForm[this.namePath].datos_afiliado.documento }
                                            descuentos_referidos.id_datos_afiliado = this.dataForm[this.namePath].datos_afiliado.referido.id
                                            descuentos_referidos.id_info_afiliacion = null,
                                                descuentos_referidos.descuento = this.dataForm[this.namePath].descuentos_referido.descuento

                                            this.updateDataForm({ state: 'descuentos_referido', data: descuentos_referidos })
                                            await this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado', 'info_afiliacion', 'afiliacion_registro', 'servicios_nuevos', 'servicios_activos', 'descuentos_referido'] })
                                        } else {
                                            await this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado', 'info_afiliacion', 'afiliacion_registro', 'servicios_nuevos', 'servicios_activos'] })
                                        }
                                        // se configura el dataPost	

                                        await Promise.all([await1, await2, await3, await4, await5, await6])
                                    }
                                }
                            } else {
                                let servicios_nuevos = this.dataForm[this.namePath].servicios_nuevos
                                await this.resetDataForm({ state: 'servicios_nuevos' })

                                for (let i = 0; i < this.dataMultiple[this.namePath].multiple_servicios.length; i++) {
                                    if (this.dataMultiple[this.namePath].multiple_servicios[i].check === 1) {
                                        let indexActivos = _.findIndex(servicios_nuevos, ['name', this.dataMultiple[this.namePath].multiple_servicios[i].name])
                                        if (indexActivos !== -1) {
                                            let newValue = this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
                                            await this.pushDataForm({ state: 'servicios_nuevos', data: newValue })
                                        }
                                    }
                                }

                                let servicios_activos = this.dataForm[this.namePath].servicios_activos
                                await this.resetDataForm({ state: 'servicios_activos' })

                                for (let i = 0; i < this.dataMultiple[this.namePath].multiple_servicios.length; i++) {
                                    if (this.dataMultiple[this.namePath].multiple_servicios[i].check === 1) {
                                        let indexActivos = _.findIndex(servicios_activos, ['name', this.dataMultiple[this.namePath].multiple_servicios[i].name])
                                        if (indexActivos !== -1) {
                                            let newValue = this.deepCopy(this.dataMultiple[this.namePath].multiple_servicios[i])
                                            await this.pushDataForm({ state: 'servicios_activos', data: newValue })
                                        }
                                    }
                                }

                                await this.updateDataPost({
                                    data: {
                                        data: [],
                                        route: 'save_all',
                                        tablaAuditar: true,
                                        notaDelete: null,
                                        tablaPost: ['datos_afiliado', 'info_afiliacion', 'servicios_activos', 'servicios_nuevos'],
                                        tablaDelete: []
                                    }
                                })

                                let descuentos_referidos = {}
                                if (this.dataForm[this.namePath].datos_afiliado.referido !== null && this.dataForm[this.namePath].descuentos_referido.descuento > 0) {
                                    descuentos_referidos.id = null
                                    descuentos_referidos.referido = { name: name.replace(re, ' '), documento: this.dataForm[this.namePath].datos_afiliado.documento }
                                    descuentos_referidos.id_datos_afiliado = this.dataForm[this.namePath].datos_afiliado.referido.id
                                    descuentos_referidos.id_info_afiliacion = null,
                                        descuentos_referidos.descuento = this.dataForm[this.namePath].descuentos_referido.descuento

                                    this.updateDataForm({ state: 'descuentos_referido', data: descuentos_referidos })

                                    await this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado', 'info_afiliacion', 'servicios_nuevos', 'servicios_activos', 'descuentos_referido'] })
                                } else {
                                    await this.updateDataPost({ state: 'tablaPost', data: ['datos_afiliado', 'info_afiliacion', 'servicios_nuevos', 'servicios_activos'] })
                                }
                            }
                            break;

                    }
                }

                await this.save(event.save)

                const await20 = this.resetDataIndex()
                const await21 = this.resetGlobal({ state: 'openModal' })
                const await22 = this.onInit()
                const await23 = this.resetGlobal({ state: 'saveConfig/capa' })
                const await24 = this.resetGlobal({ state: 'saveConfig/saveloading' })
                await Promise.all([await20, await21, await22, await23, await24])

                return true

            } catch (e) {
                console.log(e)
            }
        }
    },
}